import { trialSegmentation } from "../constants";
import { SegmentationType } from "../types";

export default function getSegmentationDesc(type: SegmentationType) {
  const mapping = trialSegmentation();

  return mapping ? mapping[type] : "";
}
